// src/utils/errorReporter.js
import { apiFetch } from './apiClient';
import { BASE_URL } from './config';

// In-memory cache to track errors reported during the current session.
const reportedErrorsCache = new Set();

/**
 * Reports a frontend error to the backend.
 * @param {Error} error - The error object.
 * @param {object} errorInfo - The React error info object with componentStack.
 * @param {object} userContext - The user context containing user info.
 */
export const reportError = (error, errorInfo, userContext) => {
  // Create a unique key for the error to prevent duplicates.
  // A combination of the message and stack is usually sufficient.
  const errorKey = `${error.message}|${error.stack}`;

  // If this exact error has already been reported in this session, do nothing.
  if (reportedErrorsCache.has(errorKey)) {
    return;
  }
  reportedErrorsCache.add(errorKey);

  try {
    const payload = {
      errorMessage: error.message,
      errorStack: error.stack,
      componentStack: errorInfo?.componentStack,
      location: window.location.href,
      userInfo: userContext?.user?.isLoggedIn ? `User: ${userContext.user.username} (ID: ${userContext.user.id})` : 'Guest',
    };

    // We don't need to await this. Fire and forget.
    apiFetch(`${BASE_URL}/api/general/report-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (reportingError) {
    // If reporting fails, log it to the console to avoid an infinite loop.
    console.error('Failed to report error to backend:', reportingError);
  }
};
